import { createFileRoute } from "@tanstack/react-router";
import { PlaybookConnections } from "../../../components/playbooks/playbook-tabs";

/** Connections: what the playbook's steps use. */
export const Route = createFileRoute(
  "/_authenticated/_workspace/playbooks/$playbookId/connections",
)({
  component: function PlaybookConnectionsRoute() {
    const { playbookId } = Route.useParams();
    return <PlaybookConnections playbookId={playbookId} />;
  },
});
